export enum Brand {
    Dacia = 'Dacia',
    Renault = 'Renault',
    Nissan = 'Nissan',
    Hyundai = 'Hyundai',
    KGM = 'KGM',
    Isuzu = 'Isuzu',
    Suzuki = 'Suzuki',
  }